import y, { formatByNamedArgs, getQuery } from './Utils';
import { get } from './Y4Api';
import is from 'is_js';
import { md5 } from './Utils';
import wx from 'weixin-js-sdk';
import RT from './RT';
import _ from 'lodash';
import { log } from './Y4Api';

function isWeiXinBrowser() {
  return is.include(navigator.userAgent, 'MicroMessenger/');
}

function getUserInfoFromSession(config) {
  var k = `weixin_${config}_user`;
  const s = y.getSessionItem(md5(k) + '_w');
  if (s) {
    return JSON.parse(s);
  } else return null;
}

function setUserInfoToSession(config, user) {
  var k = `weixin_${config}_user`;
  y.setSessionItem(md5(k) + '_w', JSON.stringify(user));
}

/**
 * Get WeiXin user info from WeiXin service by code that created after redirect
 * @param {*} config
 * @param {*} code
 * @returns
 */
async function getUserInfo(config, code) {
  return await get('WeiXin', 'GetSnsUserInfo', { config, code });
}

/**
 * Enable wx functioins
 * @param {*} config
 * @param {*} url
 * @param {*} jsApiList
 * @returns
 */
async function enableJsApi(config, url, jsApiList, debug = false) {
  const rt = await get('WeiXin', 'GetJsApiConfigInfo', { config, url });
  if (rt.isNotOk()) {
    log(`WeiXin-enableJsApi-${config}-error`, rt.message);
    return rt;
  }
  const options = { ...rt.data, jsApiList, debug };
  delete options.token;
  if (debug) {
    log(`WeiXin-enableJsApi-${config}-options`, options);
  }
  wx.config(options);
  return new RT();
  /*
  wx.config({
    debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: '', // 必填，公众号的唯一标识
    timestamp: '', // 必填，生成签名的时间戳
    nonceStr: '', // 必填，生成签名的随机串
    signature: '', // 必填，签名
    jsApiList: [] // 必填，需要使用的JS接口列表
  });
  */
}

/**
 * Create redirect url
 * @param {*} appId
 * @param {*} url
 * @param {*} scope
 * @param {*} state
 * @returns
 */
function getRedirectUrl(appId, url, scope, state) {
  return formatByNamedArgs(
    'https://open.weixin.qq.com/connect/oauth2/authorize?appid={appId}&redirect_uri={url}&response_type=code&scope={scope}&state={state}#wechat_redirect',
    {
      appId,
      url: encodeURIComponent(url),
      scope,
      state
    }
  );
}

/**
 *
 * @param {*} f
 * @param {*} withWeiXin
 * @param {*} withoutWeiXin
 * @param {*} error
 */
function initWinXinInPage(f, withWeiXin, withoutWeiXin, error) {
  if (isWeiXinBrowser()) {
    const wx_option = _.get(f, 'option.weixin');
    if (wx_option) {
      const wx_config = _.get(wx_option, 'config');
      //weixin form
      let wx_user = getUserInfoFromSession(wx_config);
      if (!wx_user) {
        //no weixin openid
        const wx_code = getQuery(location.search, 'code');
        const wx_state = getQuery(location.search, 'state');
        if (!wx_code || Date.now() - parseInt(wx_state) > 10000 /*10 second*/) {
          //not weixin call
          error({
            title: _.get(wx_option, 'redirect.title'),
            description: _.get(wx_option, 'redirect.message')
          });
          //remove old timeout info
          const usp = new URLSearchParams(location.search);
          usp.delete('code');
          usp.delete('state');
          //genrate redirect url
          const root = window.location.href.split('?')[0];
          var url = root + '?' + usp.toString();
          var redirect_url = getRedirectUrl(
            wx_option.appId,
            url,
            wx_option.scope,
            Date.now()
          );
          window.location.replace(redirect_url);
        } else {
          //weixin redirect to here
          error({
            title: _.get(wx_option, 'load.title'),
            description: _.get(wx_option, 'load.message')
          });
          //load user info
          getUserInfo(wx_config, wx_code).then(rt => {
            wx_user = _.get(rt, 'data');
            setUserInfoToSession(wx_config, wx_user);
            withWeiXin(wx_user);
            enablePageJsApi(f);
          });
        }
      } else {
        //has WeiXin user info
        withWeiXin(wx_user);
        enablePageJsApi(f);
      }
    } else {
      //in weixin but not weixin page
      withoutWeiXin();
    }
  } else {
    //not in weixin
    withoutWeiXin();
  }
}

function enablePageJsApi(f) {
  const apis = _.get(f, 'option.weixin.jsApiList');
  const config = _.get(f, 'option.weixin.config');
  if (apis) {
    enableJsApi(
      config,
      window.location.href,
      apis,
      !!_.get(f, 'option.weixin.debug')
    );
  }
}

function initWinXinShare({
  config,
  title,
  description,
  link,
  imageUrl,
  success
}) {
  if (isWeiXinBrowser()) {
    wx.updateAppMessageShareData({
      title: title ?? y.gpv(config, 'share.title'),
      desc: description ?? y.gpv(config, 'share.description'),
      link: link,
      imgUrl: imageUrl ?? y.gpv(config, 'share.image'),
      success: success,
      fail: e => {
        log('WeiXin-updateAppMessageShareData-error', e);
      }
    });
    wx.updateTimelineShareData({
      title: title ?? y.gpv(config, 'share.title'),
      link: link,
      imgUrl: imageUrl ?? y.gpv(config, 'share.description'),
      success: success ?? y.gpv(config, 'share.image'),
      fail: e => {
        log('WeiXin-updateTimelineShareData-error', e);
      }
    });
  }
}

export { isWeiXinBrowser, initWinXinInPage, initWinXinShare };
